import * as types from './mutation_types'

export default {
  [types.DONATE_SHOW_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  }
}
